// Copyright (c) 2020 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {getSpaClaim} from '../../shared/repositories';
import {readSpaTypes} from './spa-types';

export const readSpaClaim = claimNumber =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const spaClaimsArray = await getSpaClaim(claimNumber);

            const spaClaims = spaClaimsArray[0];

            dispatch({
                data: spaClaims,
                type: actions.UPDATE_TABM_SPA_CLAIM_DETAILS
            });

            dispatch(readSpaTypes(spaClaims.responsibleAccount.account));

        } catch (error) {
        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/tabm/spa-details/action-creators/get-spa-claim.js